<template>
  <div class="select is-fullwidth">
    <select name="" id="" @change.prevent="isEmpty(id) ? selectSection() : () => {}" v-model="selected_section_id" :disabled="!isEmpty(id)">
      <option value="">Pilih Sesi</option>
      <option v-for="(section, key) in sections" :key="key" :value="section.id">{{ section.meet }} ({{ section.topic || '-' }})</option>
    </select>
  </div>
</template>

<script>
import { SECTION } from '~/consts';

export default {
  props: {
    onSelect: {
      type: Function,
      default: () => {}
    },
    group_id: {
      required: true
    },
    id: {
      default: null
    }
  },

  mounted() {
    this.getSections();

    if (!this.isEmpty(this.id)) {
      this.selected_section_id = this.id;

      this.selectSection();
    }
  },

  watch: {
    group_id(val) {
      if (!this.isEmpty(val)) {
        this.getSections();
      }
    }
  },

  data() {
    return {
      selected_section_id: !this.isEmpty(this.id) ? _.clone(this.id) : '',
      sections: []
    }
  },

  methods: {
    selectSection() {
      const section = collect(this.sections).where('id', '==', this.selected_section_id).first();
      this.onSelect(section)
    },
    getSections() {
      const vm = this;

      this.$axios.post(SECTION.GET_ALL(this.group_id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.sections = data.data;
          } else {
            toast.danger(data.applicationSystem.message);
          }
        }).catch(() => {

        })
    }
  }
}
</script>
